import { useState } from 'react'

import { menuItem } from '../../utils/helper'
import Layout from '../../components/layout/layout'
import CustomSplitter from '../../components/splitter/splitter'

import RightContent from './right-content/right-content'
import LeftContent from './left-content/left-content'

import "./index.css"

const ShotExamples = () => {
    const [ selectedGridRow , setSelectedGridRow ] = useState( {} )
  return (
     <Layout menuItem={menuItem} location={"/shotexamples"}>
        <CustomSplitter>
           <div className='few-shot-left-con'>
         <LeftContent selectedGridRow={selectedGridRow} setSelectedGridRow={setSelectedGridRow}/>
        </div>
        <div className='few-shot-right-con'>
         <RightContent selectedGridRow={selectedGridRow}/>
        </div>
        </CustomSplitter>
     </Layout>
  )
}

export default ShotExamples